import { Select } from '../../../shared/components';
import { ParamUser, ParamActivity } from '../../../shared/services/settings/types';
import { Novedad } from '../../../shared/services/operationTimes/types';

/**
 * Filtros de Consolidado - INDEPENDIENTES de los de Control de Tiempos
 * (ver ActivityFilters.tsx). No comparten estado ni componente a proposito:
 * esta pantalla es de alcance global (todos los usuarios, sin bloqueo de
 * usuario) y esta pensada para crecer con filtros propios a futuro sin
 * arriesgar la pantalla de Tiempos.
 */
export interface ConsolidadoFiltersState {
  userId: string;
  activityId: string;
  dateFrom: string;
  dateTo: string;
  novedad: Novedad | '';
}

interface ConsolidadoFiltersProps {
  value: ConsolidadoFiltersState;
  onChange: (value: ConsolidadoFiltersState) => void;
  users: ParamUser[];
  activities: ParamActivity[];
}

const NOVEDAD_OPTIONS = [
  { value: 'modified', label: 'Modificado' },
  { value: 'deleted', label: 'Borrado' },
];

export function ConsolidadoFilters({ value, onChange, users, activities }: ConsolidadoFiltersProps) {
  const update = (patch: Partial<ConsolidadoFiltersState>) => onChange({ ...value, ...patch });

  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-5">
      <Select
        placeholder="Todos los usuarios"
        options={users.map((u) => ({ value: u.id, label: u.fullName }))}
        value={value.userId}
        onChange={(e) => update({ userId: e.target.value })}
      />
      <Select
        placeholder="Todas las actividades"
        options={activities.map((a) => ({ value: a.id, label: a.name }))}
        value={value.activityId}
        onChange={(e) => update({ activityId: e.target.value })}
      />
      <label className="block">
        <input
          type="date"
          value={value.dateFrom}
          onChange={(e) => update({ dateFrom: e.target.value })}
          className="h-[50px] w-full rounded-xl border border-ink-200 bg-surface px-3 text-sm outline-none focus:ring-2 focus:ring-brand-200"
        />
      </label>
      <label className="block">
        <input
          type="date"
          value={value.dateTo}
          onChange={(e) => update({ dateTo: e.target.value })}
          className="h-[50px] w-full rounded-xl border border-ink-200 bg-surface px-3 text-sm outline-none focus:ring-2 focus:ring-brand-200"
        />
      </label>
      <Select
        placeholder="Novedad: todas"
        options={NOVEDAD_OPTIONS}
        value={value.novedad}
        onChange={(e) => update({ novedad: e.target.value as Novedad | '' })}
      />
    </div>
  );
}
